// (c) Copyright Ascensio System SIA 2009-2025
//
// This program is a free software product.
// You can redistribute it and/or modify it under the terms
// of the GNU Affero General Public License (AGPL) version 3 as published by the Free Software
// Foundation. In accordance with Section 7(a) of the GNU AGPL its Section 15 shall be amended
// to the effect that Ascensio System SIA expressly excludes the warranty of non-infringement of
// any third-party rights.
//
// This program is distributed WITHOUT ANY WARRANTY, without even the implied warranty
// of MERCHANTABILITY or FITNESS FOR A PARTICULAR  PURPOSE. For details, see
// the GNU AGPL at: http://www.gnu.org/licenses/agpl-3.0.html
//
// You can contact Ascensio System SIA at Lubanas st. 125a-25, Riga, Latvia, EU, LV-1021.
//
// The  interactive user interfaces in modified source and object code versions of the Program must
// display Appropriate Legal Notices, as required under Section 5 of the GNU AGPL version 3.
//
// Pursuant to Section 7(b) of the License you must retain the original Product logo when
// distributing the program. Pursuant to Section 7(e) we decline to grant you any rights under
// trademark law for use of our trademarks.
//
// All the Product's GUI elements, including illustrations and icon sets, as well as technical writing
// content are licensed under the terms of the Creative Commons Attribution-ShareAlike 4.0
// International. See the License terms at http://creativecommons.org/licenses/by-sa/4.0/legalcode

import styled, { css } from "styled-components";
import { mobile, tablet } from "@docspace/shared/utils";
import { isIOS, isFirefox } from "react-device-detect";

import BackgroundPatternReactSvgUrl from "PUBLIC_DIR/images/background.pattern.react.svg?url";

export const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  box-sizing: border-box;
  background-image: url("${BackgroundPatternReactSvgUrl}");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;

  .logo-wrapper {
    max-width: 386px;
    display: block;
    padding-bottom: 40px;
  }

  @media ${mobile} {
    background-image: none;
    height: 0;

    .logo-wrapper {
      display: none;
    }
  }

  height: ${isIOS && !isFirefox ? "calc(var(--vh, 1vh) * 100)" : "100vh"};
  width: 100vw;

  @media ${tablet} {
    padding: 0 16px;
  }

  @media ${mobile} {
    ${(props) =>
      props.theme.interfaceDirection === "rtl"
        ? css`
            padding: 0 16px 0 8px;
          `
        : css`
            padding: 0 8px 0 16px;
          `}
  }

  .subtitle {
    margin-bottom: 32px;
  }

  .password-form {
    width: 100%;
    margin-bottom: 8px;
  }

  .subtitle {
    margin-bottom: 32px;
  }

  .public-room_content-wrapper {
    display: flex;
    flex-direction: column;
    -webkit-box-align: center;
    align-items: center;
    margin: 0px auto;
    max-width: 960px;
    box-sizing: border-box;
    height: 100%;
  }

  .public-room-content {
    padding-top: 9%;
    justify-content: unset;
    min-height: unset;

    .public-room-text {
      margin: 8px 0;
      white-space: wrap;
    }

    .public-room-name {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 32px;
    }

    .public-room-icon {
      min-width: 32px;
      min-height: 32px;
    }
  }
`;

export const StyledContent = styled.div`
  min-height: 100vh;
  flex: 1 0 auto;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;

  @media ${mobile} {
    justify-content: start;
    min-height: 100%;
  }

  .bold {
    font-weight: 600;
  }
`;

export const StyledBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 56px auto;

  @media ${mobile} {
    width: 100%;
    margin: 0 auto;
  }

  .title {
    margin-bottom: 32px;
    text-align: center;
  }

  .subtitle {
    margin-bottom: 32px;
  }

  .portal-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 64px;
    max-width: 386px;
  }

  .password-field-wrapper {
    width: 100%;
  }

  .password-change-form {
    margin-top: 32px;
    margin-bottom: 16px;
  }

  .phone-input {
    margin-bottom: 24px;
  }

  .delete-profile-confirm {
    margin-bottom: 8px;
  }

  .phone-title {
    margin-bottom: 8px;
  }
`;

export const Container = styled.section`
  display: flex;
  flex-direction: column;

  height: fit-content;
  min-height: 100%;

  & > #public-password-page {
    flex: 1 0 auto;
    min-height: 0;
  }
`;

export const StyledSimpleNav = styled.div`
  display: none;
  height: 48px;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme?.login?.navBackground};

  .logo {
    height: 24px;
  }

  @media ${mobile} {
    display: flex;

    .language-combo-box {
      position: absolute;
      top: 7px;
      right: 8px;
    }
  }
`;
